import { maxLength, ReferenceInput, required, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { employeeRequests } from "api/employeeApi";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="residentialNumber"
          label="Номер"
          fullWidth
          validate={[required(), maxLength(150)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          reference={employeeRequests.getEmployeesSelect()}
          source="houseManagerEmployeeId"
        >
          <DormitoryAutocompleteInput
            label="Управител"
            fullWidth
            validate={[required()]}
            optionText={rec =>
              rec.secondName ? `${rec.firstName} ${rec.secondName} ${rec.lastName}` : `${rec.firstName} ${rec.lastName}`
            }
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};
export default SaveForm;
